import React from 'react';

// components/LoadingOverlay.js
const LoadingOverlay = ({ label = 'Procesando solicitud…' }) => (
    <div className="fixed inset-0 bg-black bg-opacity-30 z-[9999] flex flex-col gap-4 items-center justify-center" role="status" aria-live="polite">
      <div className="w-16 h-16 border-4 border-white border-t-transparent rounded-full animate-spin" aria-hidden="true" />
      <span className="rounded-lg bg-white px-4 py-2 text-sm font-semibold text-gray-800">{label}</span>
    </div>
  );
  export default LoadingOverlay;
